import { render, staticRenderFns } from "./Alarmas.vue?vue&type=template&id=c8a63152&"
import script from "./Alarmas.vue?vue&type=script&lang=js&"
export * from "./Alarmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports